import { render, staticRenderFns } from "./ErrorInfo.vue?vue&type=template&id=1229879e&scoped=true&"
import script from "./ErrorInfo.vue?vue&type=script&lang=ts&"
export * from "./ErrorInfo.vue?vue&type=script&lang=ts&"
import style0 from "./ErrorInfo.vue?vue&type=style&index=0&id=1229879e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1229879e",
  null
  
)

export default component.exports